var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.145,
    height: 52.067,
    viewBox: "0 0 38.145 52.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-10 -1.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M26.6,38.24H35.27a2.609,2.609,0,0,0,2.6-2.6V33.776A6.942,6.942,0,0,0,32.36,27.02,7.109,7.109,0,0,0,24,33.776V35.64A2.609,2.609,0,0,0,26.6,38.24Zm4.335-7.932a2.6,2.6,0,1,1-2.6,2.6A2.6,2.6,0,0,1,30.935,30.308Z",
    transform: "translate(-1.863 -3.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M18,17.448a2.609,2.609,0,0,0,2.6,2.6h2.6v6.823a8.6,8.6,0,0,1,3.225-2.644,7.959,7.959,0,0,1,1.977-.659v-3.52h3.468v3.52a7.827,7.827,0,0,1,1.994.668,9.007,9.007,0,0,1,3.208,2.609v-6.8h2.6a2.609,2.609,0,0,0,2.6-2.6V13.98H18Z",
    transform: "translate(-1.065 -1.597)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 38.145,
    height: 8.669,
    rx: 3,
    transform: "translate(10 1.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M38.565,49.878a2.731,2.731,0,0,0-2.393,1.9,3.541,3.541,0,0,1-3.962,2.358,3.444,3.444,0,0,1-.971-6.485,4.174,4.174,0,0,0,2.3-3.936V41.98h-5.2v.867a.727.727,0,0,1-.312.668,8.583,8.583,0,0,0-4,7.88,8.826,8.826,0,0,0,17.2,1.812,2.632,2.632,0,0,0-2.661-3.329Z",
    transform: "translate(-1.864 -5.323)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.04755a370ab197aa38da7c601b0790f6.svg";
export { ForwardRef as ReactComponent };